/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable prefer-const */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */
// import React from 'react';

export const getCookie = (cookieName: string) => {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null; // Retorna null si no se encuentra la cookie
};

// Obtén y parsea la cookie 'columnVisibilityModel'
const useGetCookie = (cookie:string) => {
  const cookieValue = getCookie(cookie);
  if (cookieValue) {
    try {
      // Convierte el string JSON de la cookie a un objeto
      return JSON.parse(cookieValue);
    } catch (error) {
      console.error('Error parsing cookie JSON:', error);
    }
  }
  return null; // Retorna null si no se encuentra la cookie o hay un error
};

export default useGetCookie;
